module.exports = __webpack_public_path__ + "img/pc-en.1ab625a8.jpg";